import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { initGAnalytics } from 'services/analytics'
import { initToken } from '../utils/token/token'

export default function ProtectedRoutes() {
  const [token, setToken] = useState('')

  const getToken = async () => {
    const response = await initToken()
    setToken(response)
  }

  useEffect(() => {
    getToken()
    initGAnalytics()
  }, [])

  return token ? <Outlet /> : null
}
